import { HttpClient } from '@angular/common/http';
import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NgbDropdownConfig } from '@ng-bootstrap/ng-bootstrap';
import { DataTableDirective } from 'angular-datatables';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subject } from 'rxjs';
import { FilterProjectDto } from 'src/app/web/interfaces/project/list/filterProjectDto';
import { FilterProjectInfoDto } from 'src/app/web/interfaces/project/list/filterProjectInfoDto';
import { FilterProjectInfoFrenteDto } from 'src/app/web/interfaces/project/list/filterProjectInfoFrenteDto';
import { FilterProjectInfoItemDto } from 'src/app/web/interfaces/project/list/filterProjectInfoItemDto';
import { FilterProjectStadoDto } from 'src/app/web/interfaces/project/list/filterProjectStadoDto';
import { ViewProject } from 'src/app/web/interfaces/project/list/viewProjectDto';
import { DropdownSettingsStado, FormatDataTableGlobal, GetPermisses } from 'src/app/web/util/formatDataTable';
import Swal from 'sweetalert2/dist/sweetalert2.js'; 
import { ApiServiceProject } from '../../../apis/ApiServiceProject';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { ErrorService } from 'src/app/shared/services/errors.service';



@Component({
  selector: 'app-list-project',
  templateUrl: './list-project.component.html',
  styleUrls: ['./list-project.component.scss']
})
export class ListProjectComponent implements AfterViewInit, OnDestroy, OnInit {

  @ViewChild(DataTableDirective, {static: false})
  dtElement: DataTableDirective;
  dtTrigger = new Subject();
  dtOptions: DataTables.Settings = {};

  private apiService: ApiServiceProject;
  
  searchForm: FormGroup;
  listViewProjectDto: ViewProject[] = []
  listViewProjectDtoBack: ViewProject[] = []
  filterProjectInfoDto: FilterProjectInfoDto = {} as FilterProjectInfoDto
  filterProjectInfoFrenteDto: FilterProjectInfoFrenteDto[] = []
  filterProjectDto: FilterProjectDto = {} as FilterProjectDto;
  
  selectedItems = [];
  dropdownSettings = {};
  opcionClient = 0
  opcionFrete = 0
  opcionSeleccionado = "todo";

  permisoInfo = true;
  permisoOptionAdmin = true;
  permisoOptionAdminTeam = true;
  permisoContractAnnex = true;
  permisoDetailProject = true;
  permisoCostEffectiveness = true;
  permisoPayment = true;
  
  idProject: number;

  constructor(private http: HttpClient,
    private spinner: NgxSpinnerService,
    config: NgbDropdownConfig,
    private fb: FormBuilder,
    private router: Router,
    private activatedRouter : ActivatedRoute,
    private errorService:ErrorService
  ) 
    {
      config.placement = 'bottom';
    }

  ngOnInit(): void {

    this.permisoInfo = GetPermisses(10);
    this.permisoOptionAdmin = GetPermisses(4);
    this.permisoOptionAdminTeam = GetPermisses(5);
    this.permisoContractAnnex = GetPermisses(8);
    this.permisoDetailProject = GetPermisses(9);
    this.permisoCostEffectiveness = GetPermisses(7);
    this.permisoPayment = GetPermisses(6);

    this.dtOptions = FormatDataTableGlobal();
    this.dropdownSettings = DropdownSettingsStado();
    this.apiService =  new ApiServiceProject(this.http);

    this.searchForm = this.fb.group({
      stado: [],
      client: {},
      frete: {},
      type: {},
      item: [],
    });

    this.searchForm.get('client').setValue(0);
    this.searchForm.get('frete').setValue(0);
    this.searchForm.get('type').setValue(0);

    let listFilterTaasStadoDto: FilterProjectStadoDto[] = []

    let filterTaasStadoDto: FilterProjectStadoDto = {
      active: 1,
      closed: 0,
      stop: 0
    };

    listFilterTaasStadoDto.push(filterTaasStadoDto)

    this.filterProjectDto.client_id = 0
    this.filterProjectDto.frentes_id = 0
    this.filterProjectDto.itemSelect = [1,2,3,4,5,9,16,17]
    this.filterProjectDto.type_id = 0
    this.filterProjectDto.stado = listFilterTaasStadoDto


    this.spinner.show();

    this.apiService.getService("list-project-filter").subscribe({
      next: (rs:any) => {

        if(rs.code == null){
          this.filterProjectInfoDto = rs
          
          let payNotDay =  this.filterProjectInfoDto.listStado.filter( n =>  n.id == 1)
          
          this.selectedItems = [payNotDay[0]];

          let filterProjectInfoItemDto: FilterProjectInfoItemDto[] = []

          for(let info of this.filterProjectInfoDto.listItem){
            if(info.id == 1 || info.id == 2 || info.id == 3 || info.id == 4 || info.id == 5 
              || info.id == 9 || info.id == 16 || info.id == 17){
                filterProjectInfoItemDto.push(info)
              }

          }

          this.searchForm.get('item').setValue(filterProjectInfoItemDto);

          this.searchForm.get('stado').setValue(this.selectedItems);

          this.spinner.hide()
          this.searchInfo(this.filterProjectDto)
        }else{
          this.spinner.hide()
          Swal.fire({title:rs.error,text: '',icon: 'error',heightAuto: false});
        }
      
      },
      error: (error) => {
        this.errorService.error(error)

        }
        
      
    });

  }

  get form() {
    return this.searchForm.controls;
  }

  onItemSelect(item: any) {

  }

  actionSelectClient(){
    this.filterProjectInfoFrenteDto = this.form['client'].value.listFrente;

  }

  btnSearch() {
    let idFrente = 0;
    let idClient = 0;
    let idType = 0;

    let activeEnd = 0;
    let closedEnd = 0;
    let stopEnd = 0;


    if(this.form['client'].value.id != null){
      idClient = this.form['client'].value.id ;

      if(this.form['frete'].value.id != null){
        idFrente = this.form['frete'].value.id ;
      }
    }

    if(this.form['type'].value.id != null){
      idType = this.form['type'].value.id ;
    }
    if(this.form['stado'].value[0] != null){
      let activos =  this.form['stado'].value.filter( n =>  n.name == "Activos")
      let pausados =  this.form['stado'].value.filter( n =>  n.name == "Pausados")
      let cerrados =  this.form['stado'].value.filter( n =>  n.name == "Cerrados")

      if(activos[0] != null){
        activeEnd = 1
      }
      if(pausados[0] != null){
        stopEnd = 1
      }
      
      if(cerrados[0] != null){
        closedEnd = 1
      }
    }else{
      Swal.fire({title:"Debe selecciona una de estado",text: '',icon: 'error',heightAuto: false});
      return;
    }

    let item = []
    for(let info of this.form['item'].value){
      item.push(info.id)
    }

    if(item.length == 0){
      Swal.fire({title:"Debe selecciona un Item",text: '',icon: 'error',heightAuto: false});
      return;
    }


    let listFilterTaasStadoDto: FilterProjectStadoDto[] = []

    let filterTaasStadoDto: FilterProjectStadoDto = {
      active: activeEnd,
      closed: closedEnd,
      stop: stopEnd
    };

    listFilterTaasStadoDto.push(filterTaasStadoDto)

    this.filterProjectDto.client_id = idClient
    this.filterProjectDto.frentes_id = idFrente
    this.filterProjectDto.itemSelect = item
    this.filterProjectDto.type_id = idType
    this.filterProjectDto.stado = listFilterTaasStadoDto

    this.searchInfo(this.filterProjectDto)
  }

  searchInfo(info:FilterProjectDto){

    this.spinner.show();

    this.apiService.postService("list-project",info).subscribe({
      next: (rs:any) => {


        if(rs.code == null){
          localStorage.setItem("info-mtn", JSON.stringify(rs));
          this.listViewProjectDto = [];
          this.listViewProjectDtoBack = [];
          this.opcionSeleccionado = "todo"
          this.listViewProjectDto = rs
          this.listViewProjectDtoBack = rs;
          this.spinner.hide()
          this.rerender()
        }else{
          this.listViewProjectDto = [];
          this.listViewProjectDtoBack = [];
          this.rerender()
          this.spinner.hide()
          Swal.fire({title:rs.error ,text: '',icon: 'error',heightAuto: false});
        }
      
      },
      error: (error) => {
        this.errorService.error(error)
      }
    });
  }
  
  actionSelectFiter(opcionSeleccionado:any){
    this.listViewProjectDto = this.listViewProjectDtoBack 

    if(opcionSeleccionado.target.value == "todo"){
      this.rerender()
      return;
    }

    this.listViewProjectDto = this.listViewProjectDto.filter( n =>  n.payment.colorStatus == opcionSeleccionado.target.value)

    if(this.listViewProjectDto[0] == null){
      this.listViewProjectDto = []
    }
    this.rerender()

  }

  ngAfterViewInit(): void {
    this.dtTrigger.next();
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next();
    });
  }

  projectDetails(id: number) {
    this.router.navigate([`/pdg/project/list/view/${id}`]);
  }
  

  contractAnnex(id: number) {
    this.router.navigate([`project/edit/${id}/4`]);
  }



  projectActivated(id:any){

      this.idProject = id;
      Swal.fire({
        title: 'Activar',
        text: `¿Esta seguro de activar el proyecto ?`,
        icon: 'question',
        showCancelButton:true,
        confirmButtonText:'Aceptar',
        cancelButtonColor:"No, cancelar",
        heightAuto: false
      }).then((res) =>{
        if (res.isConfirmed) {
        this.spinner.show()
        this.apiService.putService('project-status-active?id_project='+this.idProject ).subscribe({
          next: (rs: any) =>{
            if (rs) {
              this.spinner.hide();
              Swal.fire({title:'Exito!',text:'Se ha activado el proyecto correctamente',icon: 'success',heightAuto: false}).then(()=>{location.reload()})
            }else{
              this.spinner.hide();
              Swal.fire({title:rs.error,text: '',icon: 'error',heightAuto: false});
            }
          },error: (error) =>{
            this.errorService.error(error)
          }});
  
      }else if ( res.dismiss === Swal.DismissReason.cancel){
        Swal.fire({
          title: 'Cancelado',
          text: 'Operación cancelada.',
          icon: 'error',
          heightAuto: false
          })
        }
    });
  }
  projectPaused(id:any){
    this.idProject = id;

      Swal.fire({
        title: 'Pausar',
        text: `¿Esta seguro de pausar el proyecto ?`,
        icon: 'warning',
        showCancelButton:true,
        confirmButtonText:'Aceptar',
        cancelButtonColor:"No, cancelar",
        heightAuto: false
      }).then((res) =>{
        if (res.isConfirmed) {
        this.spinner.show()
        this.apiService.putService('project-status-pause?id_project='+this.idProject ).subscribe({
          next: (rs: any) =>{
            if (rs) {
              this.spinner.hide();
              Swal.fire({title:'Exito!',text:'Se ha pausado el proyecto correctamente',icon: 'success',heightAuto: false}).then(()=>{location.reload()})
            }else{
              this.spinner.hide();
              Swal.fire({title:rs.error,text: '',icon: 'error',heightAuto: false});
            }
          },
          error: (error) => {
            this.errorService.error(error);
          },});
  
      }else if ( res.dismiss === Swal.DismissReason.cancel){
        Swal.fire({
          title: 'Cancelado',
          text: 'Operación cancelada.',
          icon: 'error',
          heightAuto: false
          })
        }
    });
  }

  openProject(id){
    this.idProject = id;
      Swal.fire({
        title: 'Abrir',
        text: `¿Esta seguro de abrir el proyecto?`,
        icon: 'question',
        showCancelButton:true,
        confirmButtonText:'Aceptar',
        cancelButtonColor:"No, cancelar",
        heightAuto: false
      }).then((res) =>{
        if (res.isConfirmed) {
        this.spinner.show()
        this.apiService.putService('project-open?id_project='+this.idProject ).subscribe({
          next: (rs: any) =>{
            if (rs) {
              this.spinner.hide();
              Swal.fire({title:'Exito!',text:'Se ha abierto el proyecto correctamente',icon: 'success',heightAuto: false}).then(()=>{location.reload()})
            }else{
              this.spinner.hide();
              Swal.fire({title:rs.error ,text: '',icon: 'error',heightAuto: false});
            }
          },error: (error) =>{
            this.errorService.error(error)
          }});
  
      }else if ( res.dismiss === Swal.DismissReason.cancel){
        Swal.fire({
          title: 'Cancelado',
          text: 'Operación cancelada.',
          icon: 'error',
          heightAuto: false
          })
        }
    });
  }
}
